export const teamMemberEn = {
  title: 'Our Team',
  description:
    'Our core team consists of industry leaders with extensive experience in the energy sector. Together, they drive innovation and ensure the highest quality of service for our clients.',
  list: [
    {
      title: 'Sean Liang',
      position: 'CEO',
      description: [
        'Extensive experience in capital operations and investment management, leading financing for advanced industries such as AI, smart hardware, energy storage.',
        'Entrepreneurial experience across global green energy sectors.',
        'Founder of the Carus commercial energy storage brand, with over 20-years in executive management and',
        'project development in sustainable technology.',
        ' Career Highlights – ',
        'Co-founder of the North American PhG home energy storage brand, leading the development of the product line and the establishment of marketing channels.',
        'Previously served as Vice President and COO among other core executive positions at LY Group, leading the creation of multiple product lines, business departments, and independent subsidiary platforms.',
        'Founded Shenzhen CYF Company, achieving over a hundred million in revenue in two years, and was fully acquired by a listed company in 2018.',
      ],
    },
    {
      title: 'Daniel Sun',
      position: 'EPC Sales CEO',
      description: [
        'Licensed engineer with expertise in General Construction (B), Thermal and Photovoltaic Solar Energy Systems (C46), Flooring (C15), Hazardous Material Removal (HAZ), and Asbestos Abatement (ASB).',
        'Skilled in comprehensive remediation services, including',
        'water, fire, microbial, odor, and biohazard remediation, adhering to EPA, AQMD, OSHA, and fire department standards.',
      ],
    },
    {
      title: 'Jack Chen',
      position: 'CTO',
      description: [
        "Holds dual master's degrees from Wayne State University, with experience in various Fortune 500 companies including General Motors and CATL. Entrepreneurial experience in the internet, new energy vehicles, and energy storage industries. Accumulated over 30 years of engineering, management, sales, and trade expertise.",
      ],
    },
    {
      title: 'Justin',
      position: 'Director of Business Development',
      description: [
        '12 Years in Advanced Energy System with primary focus in business development in commercial solar industry. Educating customers with everything related to solar and beef up with his financial background on project/investment analysis',
        'Self-Employed/CEO of Justin Wilbur LLC',
        'Financial Representative in COUNTRY Financial, provided sophisticated mid term and long- term financial suggestions through out a series of analysis.',
      ],
    },
    {
      title: 'Alexia Wang',
      position: 'Marketing & Compliance Specialist',
      description: [
        'Environmental Economics and Policy major at UC Berkeley. Exploring the natural environment and economics development through the evolution of renewable energy, and explore the optimal solution between environmental protection, government policies and economic development.',
        'Career Highlights – ',
        'University of California Berkeley (UC Berkley), undergraduate – Environmental Economics & Policy',
      ],
    },
    {
      title: 'Ph.D  Dr. Liu',
      position: 'Vice President of Global Supply Chain & Sustainability Strategic Supply Chain & ESG Leader',
      description: [
        'A seasoned expert in supply chain innovation and sustainable development, Dr. Liu has established industry-leading ESG integration frameworks at multinational technology corporations. With extensive experience at global leaders like Apple, he has successfully embedded sustainability principles across the entire supply chain lifecycle, creating operational models that balance business value with social responsibility.',
        'Key Professional Achievements',
        '• Spearheaded the development and implementation of a global supplier sustainability assessment and management system to drive green transformation',
        '• Pioneered innovative applications of circular economy principles in electronics manufacturing, setting industry benchmarks for material recovery',
        '• Established a responsible sourcing network spanning multiple regions, ensuring end-to-end supply chain compliance and sustainability',
        '• Optimized manufacturing energy efficiency, significantly reducing environmental footprint',
        'Areas of Expertise',
        'Supply Chain ESG Strategy | Carbon Neutral Solutions | Circular Economy Practices | Sustainable Sourcing & Supplier Management',
        'Leadership Philosophy',
        'Transforming sustainability into a core competitive advantage through systemic innovation to build responsible supply chain ecosystems for the future.',
      ],
    },
    {
      title: 'Shanshan',
      position: 'Data Analyst ',
      description: [
        'BS in Mathematics and MS in Econometrics from New York University, with coursework in corporate finance and valuation. Expertise in statistical modeling, predictive analytics, and financial analysis to transform complex datasets into actionable insights. Applies econometric frameworks to optimize business performance, assess financial risk, and align data-driven strategies with sustainability and growth objectives.',
      ],
    },
    {
      title: 'Ming Lin',
      position: 'Vice President of Sales',
      description: [
        'Master’s degree in management, Case Western Reserve University',
        'Results-driven senior executive and entrepreneur with a proven track record in sales and supply chain management across energy, automotive, semiconductor, and medical device industries.',
        '•    Played a key role in negotiating the procurement of 14 generators and turbines for the Three Gorges Power Plant—one of the largest power plants globally.',
        '•    Founded and successfully led a medical device company, securing multiple Group Purchasing Organization (GPO) contracts and establishing a strong presence in major U.S. hospital systems.',
      ],
    },
  ],
}
